import React, { useState } from 'react';
import { string } from 'prop-types';
import clsx from 'clsx';
import ReactPlayer from 'react-player/youtube';

import PlayIcon from 'assets/images/icons/play-large.svg';

import styles from './VideoPlayer.module.scss';

const VideoPlayer = ({ youtubeId, thumbnail }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [hideCover, setHideCover] = useState(false);
  const [hideSwipeArea, setHideSwipeArea] = useState(false);

  const onPlay = () => {
    setHideSwipeArea(true);
  };

  const onPause = () => {
    setHideSwipeArea(false);
    setIsPlaying(false);
  };

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={clsx(styles.cover, {
          [styles.hideCover]: hideCover,
        })}
        style={{
          backgroundImage: `url(${
            thumbnail || `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`
            // NOTE: Will show placeholder image from YT if video does not have a hight resolution (sddefault) thumbnail image
          })`,
        }}
        onClick={() => {
          // console.log('onclick cover');
          setIsPlaying(true);
          setHideCover(true);
        }}
        label="Play video"
      >
        <div className={styles.playIcon}>
          <PlayIcon />
        </div>
      </button>

      <button
        type="button"
        className={clsx(styles.swipeArea, {
          [styles.hideSwipeArea]: hideSwipeArea,
        })}
        onClick={() => {
          setIsPlaying(!isPlaying);
        }}
        label="Play/pause video"
      />

      {hideCover && (
        <ReactPlayer
          className={styles.player}
          playing={isPlaying}
          url={`https://www.youtube.com/watch?v=${youtubeId}`}
          config={{
            youtube: {
              playerVars: {
                // https://developers.google.com/youtube/player_parameters
                modestbranding: 1, // Removes small YouTube logo in the control bar
                rel: 0, // Shows related videos from same channel
                disablekb: 1, // Disable keyboard controls
                controls: 1, // Show controls
                enablejsapi: 1,
              },
            },
          }}
          width="100%"
          height="100%"
          onPlay={onPlay}
          onPause={onPause}
        />
      )}
    </div>
  );
};

VideoPlayer.propTypes = {
  youtubeId: string.isRequired,
  thumbnail: string,
};

VideoPlayer.defaultProps = {
  thumbnail: false,
};

export default VideoPlayer;
